import { SegmentedControl } from "@softmax/design-system";
import {
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { styles } from "../wiki.styles";
import type { WikiMode } from "../wiki-types";

export function WikiPageHeader({
  layout,
  pageSlug,
  displayTitle,
  mode,
  modeItems,
  pending,
  onModeChange,
}: Readonly<{
  layout: "page" | "embedded";
  pageSlug: string;
  displayTitle: string;
  mode: WikiMode;
  modeItems: readonly Readonly<{ value: WikiMode; label: string }>[];
  pending: boolean;
  onModeChange(mode: WikiMode): void;
}>) {
  const Title = layout === "page" ? "h1" : "h2";
  return (
    <header {...stylex.props(localStyles.header)}>
      <div {...stylex.props(localStyles.headingBlock)}>
        <p {...stylex.props(styles.eyebrow)}>Wiki · {pageSlug}</p>
        <Title
          {...stylex.props(
            localStyles.title,
            layout === "embedded" && localStyles.embeddedTitle,
          )}
        >
          {displayTitle}
        </Title>
      </div>
      <SegmentedControl
        aria-label="Wiki view"
        disabled={pending}
        items={modeItems}
        value={mode === "preview" ? "edit" : mode}
        onValueChange={onModeChange}
      />
    </header>
  );
}

const localStyles = stylex.create({
  embeddedTitle: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.sectionTitle,
    letterSpacing: "normal",
  },
  headingBlock: { minWidth: 0 },
  header: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "start",
    justifyContent: "space-between",
    gap: spacing.space16,
    marginBottom: spacing.space16,
  },
  title: {
    margin: 0,
    marginTop: spacing.space4,
    fontFamily: fonts.mono,
    fontSize: {
      default: fontSizes.pageTitle,
      "@media (min-width: 768px)": fontSizes.pageTitleWide,
    },
    lineHeight: 1.11,
    fontWeight: 600,
    letterSpacing: "-1px",
    overflowWrap: "anywhere",
  },
});
